import styled from 'styled-components'

import { BqButton, BqDropdown, BqSideMenu, BqSideMenuItem } from '@beeq/react'

export const StyledBqButton = styled(BqButton)`
  ::part(label) {
    font-weight: var(--bq-font-weight--regular);
    line-height: var(--bq-font-line-height--regular);
    padding-left: var(--bq-spacing-s);
    font-size: var(--bq-font-size--m);
  }
`

export const StyledBqSideMenu = styled(BqSideMenu)`
  ::part(logo) {
    padding-top: var(--bq-spacing-l);
    padding-left: var(--bq-spacing-xl);
    padding-bottom: 50px;
  }

  ::part(footer) {
    width: 100%;
    justify-content: start;
  }
`

export const StyledBqSideMenuItem = styled(BqSideMenuItem)`
  ::part(base) {
    padding-right: var(--bq-spacing-xs3);
    font-weight: var(--bq-font-weight--regular);
    line-height: var(--bq-font-line-height--regular);
  }
`

export const StyledBqDropdown = styled(BqDropdown)`
  ::part(trigger) {
    width: 240px;
  }
  ::part(panel) {
    width: 240px;
  }
`
export const StyledDiv = styled.div`
  cursor: pointer;
`
